import { useStudyQuery } from '../../StudyPage/hooks/useStudy';

const useStudy = useStudyQuery

export default useStudy;
